import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpModule } from '@angular/http';
import { ServiceWorkerModule } from '@angular/service-worker';
// import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormBuilder, FormsModule } from '@angular/forms';
import { IonicSelectableModule } from 'ionic-selectable';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons'
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Camera, CameraOptions, CameraSource } from '@capacitor/camera';
import { environment } from '../environments/environment';
// import { Toast } from '@awesome-cordova-plugins/toast/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
// import { Toast } from '@awesome-cordova-plugins/toast/ngx';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { ImagePicker } from '@awesome-cordova-plugins/image-picker/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';

import { Device } from '@awesome-cordova-plugins/device/ngx'
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { SwiperModule } from 'swiper/angular';
import { Toast } from '@awesome-cordova-plugins/toast/ngx';
import { TranslateModule } from '@ngx-translate/core';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@awesome-cordova-plugins/native-geocoder/ngx';
// import { AppRate } from '@awesome-cordova-plugins/app-rate/ngx';
import { AppRate } from '@ionic-native/app-rate/ngx';
import { SmsRetriever } from '@awesome-cordova-plugins/sms-retriever/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, ServiceWorkerModule.register('combine-sw.js', { enabled: environment.production }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule, FormsModule,
    IonicSelectableModule,
    HttpModule,
    HttpClientModule,
    SwiperModule,
    ShareButtonsModule.withConfig({
      debug: false,
    }),
    ShareIconsModule,
    BrowserAnimationsModule,
    
    // Toast,
    // TranslateModule.forChild(
    //   {
    //     loader: {
    //       provide: TranslateLoader,
    //       useFactory: (TranslateLoader),
    //       deps: [HttpClient]
    //     }

    //   })
    TranslateModule.forRoot(),



  ],
  providers: [
    StatusBar, Keyboard, ImagePicker, Device,
    SmsRetriever,Geolocation,NativeGeocoder,AppRate,
    SocialSharing, Network,FormBuilder,
    // TranslateStore, TranslateService,
    Toast,
    FileTransfer,
    AppVersion,
    InAppBrowser,
    GoogleAnalytics,
    AndroidPermissions

    
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }
